const trimTrailingSlash = (value: string) => value.replace(/\/+$/, "");

export const ENV = {
  apiOrigin: trimTrailingSlash(
    process.env.REACT_APP_API_ORIGIN || "https://service.ireedindia.com"
  ),
  trainerApiOrigin: trimTrailingSlash(
    process.env.REACT_APP_TRAINER_API_ORIGIN || "https://service.ireedindia.com"
  ),
  requestTimeoutMs: 30000,
} as const;

